import { Button } from "@chakra-ui/react";
import clsx from "clsx";
import Image from 'next/image'
import Link from "next/link";
import { ArrowRight } from "./Icons";

const SidebarCallToAction = ({ heading, image, imageBlur, target }) => {
	const handleClick = (text, url) => {
		window.dataLayer?.push({
			event: "event",
			eventProps: {
				category: "Button Click",
				action: text,
				label: url,
			},
		});
	};
	return (
		<div className={clsx("SidebarCallToAction")}>
			{!!image && (
				<Image
					src={image.url}
					width={image.width}
					height={image.height}
					layout="responsive"
					placeholder="blur"
					blurDataURL={imageBlur.url}
					className={clsx("SidebarCallToAction__image")}
					alt={image.title}
				></Image>
			)}
			<div
				className={clsx(
					"SidebarCallToAction__caption",
					"bg-purple-gray-02 text-black-01 py-8 px-8"
				)}
			>
				<h4
					className={clsx("SidebarCallToAction__heading", "text-2xl", "mb-7.5")}
				>
					{heading}
				</h4>
				<div className={clsx("SidebarCallToAction__target")}>
					<Button
						bg="transparent"
						p={0}
						color="black-01"
						href={target?.url}
						as={target?.url && Link}
						onClick={target && (() => handleClick(target.text, target.url))}
						rightIcon={<ArrowRight />}
						target={target?.target}
						_hover={{
							background: "transparent",
							textDecoration: "underline",
						}}
					>
						{target?.text}
					</Button>
				</div>
			</div>
		</div>
	);
};

export default SidebarCallToAction;
